import { plants } from '@data/plants';

export default function Plants() {
	return (
		<>
			<h1 className="h3 mb-4">Plants</h1>
			<div className="row g-3">
				{plants.map(p => (
					<div key={p.id} className="col-12 col-md-6 col-lg-4">
						<div className="card h-100">
							<div className="card-body">
								<div className="d-flex align-items-start justify-content-between">
									<div>
										<div className="fw-bold">{p.name}</div>
										<div className="text-muted small">{p.species}</div>
									</div>
									<span className={`badge ${p.health === 'good' ? 'text-bg-success' : p.health === 'fair' ? 'text-bg-warning' : 'text-bg-danger'}`}>{p.health}</span>
								</div>
								<hr />
								<div className="d-flex flex-wrap gap-3">
									<div>
										<div className="text-muted small">Soil Moisture</div>
										<div className="fw-medium">{p.soilMoisture}%</div>
									</div>
									<div>
										<div className="text-muted small">Last Watered</div>
										<div className="fw-medium">{new Date(p.lastWateredAt).toLocaleDateString('en-GB')}</div>
									</div>
									<div>
										<div className="text-muted small">Location</div>
										<div className="fw-medium">{p.location}</div>
									</div>
								</div>
							</div>
							<div className="card-footer d-flex justify-content-end gap-2">
								<button className="btn btn-sm btn-outline-primary">View</button>
								<button className="btn btn-sm btn-outline-secondary">Edit</button>
							</div>
						</div>
					</div>
				))}
			</div>
		</>
	);
}


